<script setup>

import {onMounted, ref} from 'vue';
import Button from "@/components/forms/Button.vue";
import {formatDate, showSuccessMessage} from '../../helper';
import {createConfirmDialog} from 'vuejs-confirm-dialog';
import {getLoggedUser, refreshLoggedUser} from '@/services/AuthService';
import IntermediaryPersonsService from "@/services/IntermediaryPersonsService";
import {useDataTable} from "@/utils/datatableHelper";
import ModalDialog from "@/components/modals/ModalDialog.vue";
import FormService from "@/services/FormService";

import {useI18n} from 'vue-i18n'

const {t} = useI18n();

const props = defineProps({
  entityId: {
    type: Number,
    default: null,
  },
});

const datatable = useDataTable(fetchIntermediaryPeople, 'name', 20, true);

const intermediaryPeople = ref([]);

const isLoading = ref(false);

const isEditable = ref(false);

const columns = ref([
  {
    label: t('intermediariesPeopleListComponent.surname'),
    field: 'surname',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: t('intermediariesPeopleListComponent.firstname'),
    field: 'firstname'
  },
  {
    label: t('intermediariesPeopleListComponent.email'),
    field: 'email'
  },
  {
    label: t('intermediariesPeopleListComponent.phone'),
    field: 'phone'
  },  
  {
    label: t('intermediariesPeopleListComponent.parent'),
    field: 'parent'
  },
  {
    label: '',
    field: 'action',
    sortable: false,
    html: true
  },
]);

onMounted(async () => {
      getLoggedUser().then(response => {
        let loggedUser = response;
        if (loggedUser.role === 'ADMIN' || loggedUser.role === 'SUPERADMIN' || loggedUser.role === 'BACK_OFFICE') {
          isEditable.value = true;
        }
      });
      emitter.on('intermediaryPersonSaved', () => {
        fetchIntermediaryPeople(datatable.body);
      });
    }
);

function fetchIntermediaryPeople(body) {
  if (props.entityId) {
    datatable.filter.value.intermediary_id = props.entityId;
    IntermediaryPersonsService.fetchRecordsOfIntermediary(props.entityId, body).then(response => {
      datatable.totalRecords.value = response.meta.total;
      datatable.rows.value = response.data;
      datatable.isLoading.value = false;
    });
  } else {
    IntermediaryPersonsService.fetchRecords(body).then(response => {
      datatable.totalRecords.value = response.meta.total;
      datatable.rows.value = response.data;
      datatable.isLoading.value = false;
    });
  }
}
</script>

<template>
  <div class="table-container">
    <vue-good-table
        :columns="columns"
        :rows="datatable.rows.value"
        mode="remote"
        @page-change="datatable.onPageChange"
        @sort-change="datatable.onSortChange"
        @column-filter="datatable.onColumnFilter"
        @per-page-change="datatable.onPerPageChange"
        :totalRows="datatable.totalRecords.value"
        :pagination-options="{
                  enabled: true,
                  rowsPerPageLabel: t('intermediariesPeopleListComponent.entriesPerPage'),
                  nextLabel: t('intermediariesPeopleListComponent.next'),
                  prevLabel: t('intermediariesPeopleListComponent.previous'),
                  ofLabel: 'z',
                }">
      <template #table-row="props">
                            <span v-if="props.column.field == 'parent'">
                              {{ props.row.parent?.label }}
                            </span>
                            <span v-if="props.column.field == 'action'">
                                <span style="font-weight: bold; float: right">
                                    <router-link :to="{ name: 'IntermediaryPersonDetail', params: { id: props.row.id} }"><button type="button" class="btn btn-link"><i class="mdi mdi-eye"/></button></router-link>
                                    </span>
                            </span>
      </template>
      <template v-slot:emptystate v-if="!isLoading">
        <div class="text-center">
          {{ t('intermediariesPeopleListComponent.no_records_found') }}
        </div>
      </template>
      <template v-slot:emptystate v-if="isLoading">
        <div class="text-center">
          {{ t('intermediariesPeopleListComponent.data_loading') }}
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<style scoped>

</style>
